exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.expo-event_card[data-v-56b98cc6]::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  background: linear-gradient(\n    270deg,\n    rgba(5, 22, 46, 0.6) 20.39%,\n    rgba(5, 22, 46, 0) 61.02%,\n    rgba(5, 22, 46, 0.6) 100%\n  );\n}\n@media screen and (min-width: 1024px) {\n.stand-btn[data-v-56b98cc6] {\n    width: 25rem;\n}\n}\n", ""]);

// exports
